import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Schedule } from '../models/schedule';


@Injectable()
export class ScheduleService {

  constructor() { }

  getAllSchedulesInfo(): Observable<Schedule[]> {
    return of();
  }
}
